export const transformTripboardData = (paginatedTripBoards) => {
    let transformedData = {};
    transformedData.boards =
        paginatedTripBoards && paginatedTripBoards.tripBoards
            ? paginatedTripBoards.tripBoards.map((tripboard) => ({...tripboard, boardId: tripboard.uuid}))
            : [];

    return transformedData;
};
